import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import PageLoading from "./components/page-loading/page-loading";
import {BrowserRouter as Router} from "react-router-dom";
import {hotjar} from "react-hotjar";
import {Helmet} from "react-helmet";
import Meta from "./common/meta";

hotjar.initialize(2773160, 6);

ReactDOM.render(
  // <React.StrictMode>
    <div className="NCDM">
        {/*document title should be site at component level using <Helmet> tags*/}
        <Helmet defaultTitle={Meta.portalSiteTitle} titleTemplate={`%s${Meta.childRouteSeparator}${Meta.portalSiteTitle}`}>
            <meta charSet={'urf-8'} />
            <meta name={'description'} content={Meta.siteDescription}/>
        </Helmet>
        <React.Suspense fallback={<PageLoading />}>
            <Router>
                <App />
            </Router>
        </React.Suspense>
    </div>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
